import { TranslateFunc } from "../utils/translation.utils";

export const getActiveStatusLabel = (active: boolean | undefined, t: TranslateFunc): string => {
  return active ? t("general.active") : t("general.inactive");
};
